import TotalEngagementsChart
  from '@dashboardWirelineRetentionDepartment/TotalEngagements/TotalEngagementsChart/TotalEngagementsChart';

export default TotalEngagementsChart;
